import React from 'react';
import { Link } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import { Box, Button, Grid2, TextField, Typography } from '@mui/material';
import classNames from 'classnames';
import { AlternateEmail } from '@mui/icons-material';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { recoveredEmail } from 'js/actions/userActions';

const useStyle = makeStyles(styles);

export default function RecoveryPasswordEmail() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const rootClassName = classNames(classes.root);
  const { handleSubmit, register } = useForm();

  function onSubmit(email) {
    dispatch(recoveredEmail(email));
  }

  return (
    <Box className={rootClassName}>
      <Grid2 container={true} className={classes.grid}>
        <Grid2 className={classes.content} size={{ lg: 12, xs: 12 }}>
          <div className={classes.contentWrapper}>
            <img
              className={classes.logoimg}
              alt="Metimur Logo"
              src="/images/sistema-de-gestion-ems.png"
              width={300}
              style={{
                opacity: 0.8,
              }}
            />
            <div className={classes.formBox}>
              <div className={classes.contentBody}>
                <form
                  className={classes.form}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className={classes.divImage}>
                    <img
                      alt="Metimur Logo"
                      src="/images/logo-metimur-ems.png"
                      width={250}
                    />
                  </div>
                  <div className={classes.fields}>
                    <Typography
                      sx={{ textAlign: 'center', marginBottom: '1rem' }}
                    >
                      Ingresa tu correo electronico de recuperación
                    </Typography>
                    <TextField
                      className={classes.textField}
                      slotProps={{
                        input: {
                          startAdornment: <AlternateEmail />,
                        },
                      }}
                      type="email"
                      placeholder="Correo Electrónico"
                      variant="outlined"
                      size="medium"
                      {...register('email', { required: true })}
                    />
                  </div>
                  <Button
                    className={classes.signInButton}
                    color="secondary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Recuperar Contraseña
                  </Button>
                  <Link className={classes.iconTable} to="/login">
                    <Typography
                      color="secondary"
                      sx={{
                        marginTop: '10px',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                    >
                      Regresar
                    </Typography>
                  </Link>
                </form>
              </div>
            </div>
            <img
              className={classes.logoimg}
              alt="Metimur Logo"
              src="/images/integrated-metering-platform.png"
              width={300}
            />
          </div>
        </Grid2>
      </Grid2>
    </Box>
  );
}
